// Tiny hand-off buffer so the "Upload EOB" button can open the OS file picker
// immediately, then navigate to the full-screen loading page with the chosen file.
let pending = null;
export const setPendingEob = (file) => { pending = file || null; };
export const takePendingEob = () => { const f = pending; pending = null; return f; };
